import { connect } from 'react-redux';
import { scribeCreateTranscript, scribeDeselectTranscriptWord } from '../../../actions';
import KeyboardInput from './KeyboardInput';
const mapStateToProps = () => ({});
const mapDispatchToProps = {
    scribeCreateTranscript,
    scribeDeselectTranscriptWord,
};
export default connect(mapStateToProps, mapDispatchToProps)(KeyboardInput);
